import { css } from 'styled-components';

const TRANSITION = '400ms ease-in-out';

export const expandingSection = css`
  overflow: hidden;
  transition: height ${TRANSITION};
`;
